import submitCommand from '../../../services/submitCommand';
import { Step } from '../models/course';
import { pollFeedbackStatus } from '../utils/pollFeedbackStatus';

export const startFeedbackStep = (
  id: string,
  task: Step,
  assigneeId: string,
  email: string,
  responseId: string,
  initiatingUserId: string,
  pollForUpdate: boolean = false
) => {
  const cmd = {
    id: id,
    initiatingUserId: initiatingUserId,
    assigneeId: assigneeId,
    taskInstance: task,
    email: email,
    responseId: responseId,
  };

  const commandPromise = submitCommand(id, cmd, 'StartFeedbackTask', 'TaskInstanceStarted', 'TaskInstanceError');

  if (!pollForUpdate) {
    return commandPromise;
  }

  return pollFeedbackStatus(id, responseId, status => status !== 'not_started', {
    interval: 1000,
    maxAttempts: 5,
    initialDelay: 1000,
  });
};
